import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

export interface TypeBlockGradientCtaFields {
    internalName: EntryFieldTypes.Symbol;
    text: EntryFieldTypes.Text;
    gradient: EntryFieldTypes.Symbol<'Blue/Purple' | 'Green/Blue' | 'Purple/Pink' | 'Red/Yellow' | 'Yellow/Teal'>;
}

export type TypeBlockGradientCtaSkeleton = EntrySkeletonType<TypeBlockGradientCtaFields, 'blockGradientCta'>;
export type TypeBlockGradientCta<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockGradientCtaSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockGradientCta<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockGradientCta<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockGradientCta';
}
